import { IconProps } from "../../types";

export const ArrowRightIcon = ({ classNames }: IconProps) => (
  <span className={classNames}>
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <title />
      <g data-name="Layer 2" id="Layer_2">
        <path d="M19,26a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L26.59,16l-8.3-8.29a1,1,0,0,1,1.42-1.42l9,9a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,19,26Z" />
        <path d="M28,17H4a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z" />
      </g>
      <g id="frame">
        <rect style={{ fill: "none" }} height="32" width="32" />
      </g>
    </svg>
  </span>
);
